import { render } from "./AccountDeleteConfirmation.vue?vue&type=template&id=718786ad"
import script from "./AccountDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./AccountDeleteConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__